import React from 'react'

const None = () => {
  return (
    <div>None</div>
  )
}

export default None